import api from '../api'

export const fetchEvaluationList = async ({ 
  page, 
  employee, 
  page_size, 
  search, 
  status 
}: { 
  page: number
  employee: string
  page_size: number
  search?: string
  status?: string
}) => {
  const params: Record<string, unknown> = {
    expand: 'employee,evaluator,job_profile',
    fields: '*,employee.id,employee.first_name,employee.last_name,employee.profile_picture,evaluator.first_name,evaluator.last_name,evaluator.profile_picture,job_profile',
    page_size,
    page,
    employee,
  }

  if (search) {
    params.search = search
  }

  if (status) {
    params.status = status
  }

  const response = await api.get('/evaluations/', {
    params,
  })
  return response.data
}

interface FetchEvaluationsParams {
  page: number
  page_size: number
  search?: string
  ordering?: Array<string> | string
  filters?: Record<string, string[]>
}

export const fetchAllEmployeeEvaluations = async ({
  page,
  page_size,
  search,
  ordering,
  filters = {},
}: FetchEvaluationsParams) => {
  const params = new URLSearchParams()

  params.set('page', String(page))
  params.set('page_size', String(page_size))

  if (search) params.set('search', search)

  if (Array.isArray(ordering)) {
    ordering.forEach((o) => params.append('ordering', o))
  } else if (ordering) {
    params.set('ordering', ordering)
  }

  Object.entries(filters).forEach(([key, values]) => {
    values.forEach((value) => {
      params.append(key, value)
    })
  })

  const response = await api.get('/evaluations/latest-per-employee/', {
    params,
  })

  return response.data
}

export const fetchEvaluation = async (evaluationId: string) => {
  const response = await api.get(`/evaluations/${evaluationId}/`, {
    params: {
      expand: 'job_profile',
      fields: '*,job_profile',
    },
  })
  return response.data
}

export const addEvaluation = async (employee: unknown) => {
  const response = await api.post('/evaluations/', employee)
  return response.data
}

export const updateEvaluation = async (evaluationId: string, evaluation: unknown) => {
  const response = await api.patch(`/evaluations/${evaluationId}/`, evaluation)
  return response.data
}

export const deleteEvaluation = async (evaluationId: string | number) => {
  const response = await api.delete(`/evaluations/${evaluationId}/`)
  return response.data
}

export const approveEvaluation = async (evaluationId: number) => {
  const response = await api.put(`/evaluations/${evaluationId}/approve/`)
  return response.data
}

export const publishEvaluation = async (evaluationId: string | number) => {
  const response = await api.put(`/evaluations/${evaluationId}/publish/`)
  return response.data
}

export const evaluationEmployeeComment = async (evaluationId: string, comment: unknown) => {
  const response = await api.put(`/evaluations/${evaluationId}/employee_comment/`, comment)
  return response.data
}

export const evaluationEvaluatorComment = async (evaluationId: string, comment: unknown) => {
  const response = await api.put(`/evaluations/${evaluationId}/evaluator_comment/`, comment)
  return response.data
}

export const unpublishEvaluation = async (evaluationId: string | number) => {
  const response = await api.put(`/evaluations/${evaluationId}/unpublish/`)
  return response.data
}
